<template>
  <BTable
    id="table"
    ref="selectableTable"
    :items="products"
    :fields="fieldsProducts"
    table-class="min-h-[250px]"
    responsive
    show-empty
    :empty-text="tableEmptyText"
  >
    <template #cell(product_name)="data">
      <div class="d-flex flex-col justify-center gap-[8px] text-black min-w-[250px] h-[90px]">
        <div v-if="data.item.is_reject">
          <span class="text-[#E31A1A] bg-[#FCBEBE] text-[12px] px-[16px] py-[4px] rounded-[4px]">Ditolak</span>
        </div>
        <div class="d-flex items-center gap-[8px]">
          <img
            :src="data.item.images_path ? data.item.images_path : 'https://storage.googleapis.com/komerce/assets/icons/product-placehold.svg'"
            alt="product"
            width="52"
            height="52"
          >
          <div class="">
            <div class="font-medium">
              {{ data.item.product_name }}
            </div>
            <div class="text-primary text-[12px]">
              SKU : {{ data.item.sku }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #cell(product_variants)="{index, item}">
      <VariantList
        :item="item"
        :index="index"
      />
    </template>
    <template #cell(volume)="data">
      <div class="d-flex flex-column min-w-[75px] h-[90px] items-center justify-center">
        <div class="">
          P : {{ data.item.product_length }} cm
        </div>
        <div class="">
          L : {{ data.item.product_width }} cm
        </div>
        <div class="">
          T : {{ data.item.product_height }} cm
        </div>
      </div>
    </template>
    <template #cell(packing_detail)="data">
      <div class="min-h-[90px] flex items-center justify-center flex-col">
        <PackingList
          v-if="data.item.packing_detail"
          :packings="data.item.packing_detail"
        />
        <span v-else>-</span>
      </div>
    </template>
    <template #cell(is_product_bonus)="data">
      <div class="h-[90px] flex items-center justify-center">
        <span v-if="!data.value">-</span>
        <span
          v-else
          class="bg-primary text-white text-[12px] px-[8px] py-[4px] rounded-[4px] min-w-[130px] text-center"
        >✅ Produk Bonus</span>
      </div>
    </template>
    <template #cell(action)="data">
      <div class="h-[90px] flex items-center justify-center">
        <router-link
          :to="data.item.is_reject || !warehouseId ? '' : `/ajukan-inbound?warehouse=${warehouseId}`"
          class="btn btn-outline-primary btn-sm"
          :class="[ data.item.is_reject ? 'btn-outline-secondary !cursor-not-allowed' : 'btn-outline-primary' ]"
        >
          Ajukan Inbound
        </router-link>
      </div>
    </template>
    <template #row-details="data">
      <b-row
        class="pl-[4rem] -mt-[1rem]"
      >
        <b-col cols="12">
          <div class="flex">
            <div
              v-b-toggle="`bundling-${String(data.index)}`"
              class="flex items-center gap-[4px] py-[4px] px-[8px] rounded-[12px] !bg-[#08A0F7] text-white font-[500] cursor-pointer"
            >
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/gift.svg"
                alt="bundling"
                width="16"
              >
              <div>Bundling</div>
            </div>
          </div>
          <b-collapse
            :id="`bundling-${String(data.index)}`"
          >
            <div class="border-l-[2px] h-min p-[16px] ml-[3.5rem]">
              <div class="border rounded-t w-[80%]">
                <div class="bg-[#FFECE9] py-[8px] px-[28px] rounded-t text-black font-[500]">
                  Produk
                </div>
                <b-table
                  :items="data.item.bundle_component"
                  :fields="fieldsBundling"
                >
                  <template #cell(no)="row">
                    {{ row.index + 1 }}
                  </template>
                  <template #cell(product_name)="row">
                    <div class="flex gap-[16px] items-start">
                      <img
                        :src="row.item.images_path ? row.item.images_path : 'https://storage.googleapis.com/komerce/assets/icons/product-placehold.svg'"
                        alt="product"
                        width="52"
                        height="52"
                      >
                      <div class="space-y-[4px]">
                        <div class="font-medium">
                          {{ row.item.product_name }}
                        </div>
                        <div class="text-primary text-[12px]">
                          SKU: {{ row.item.sku }}
                        </div>
                      </div>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="flex ml-[0.8rem]">
              <div
                v-b-toggle="`bundling-${String(data.index)}`"
                class="flex items-center gap-[4px] py-[4px] px-[8px] rounded-[12px] !bg-[#F95031] text-white font-[500] cursor-pointer"
              >
                <feather-icon
                  icon="ChevronUpIcon"
                />
                <div>Tutup</div>
              </div>
            </div>
          </b-collapse>
        </b-col>
      </b-row>
    </template>
  </BTable>
</template>

<script>
import PackingList from './PackingList.vue'
import VariantList from './VariantList.vue'
import { fieldsProducts, fieldsBundling } from './config'

export default {
  name: 'ProductsTable',
  components: {
    PackingList,
    VariantList,
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
    isOnLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    warehouseId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      fieldsProducts,
      fieldsBundling,
    }
  },
  computed: {
    tableEmptyText() {
      return this.isOnLoading ? 'Memuat data...' : 'Tidak ada data yang ditampilkan.'
    },
  },
}
</script>
